export const columnDefs = [
  {
    field: 'hiringRequestId',
    headerName: 'Position ID',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'jobTitle',
    headerName: 'Job Title',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'numberOfPositions',
    headerName: 'Positions',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'lobName',
    headerName: 'LoB',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'dntLeaderName',
    headerName: 'ID&T Leader',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'createdDate',
    headerName: 'Opened Date',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'ageOld',
    headerName: 'Aging',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'vendorName',
    headerName: 'Shared by Vendor',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'priority',
    headerName: 'Priority',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'desiredStartDate',
    headerName: 'Desired Start  Date',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'location',
    headerName: 'Location',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'additionalComments',
    headerName: 'Comments',
    filterParams: { hideMenu: true },
    sortParams: { enabled: false },
  },
  {
    field: 'status',
    headerName: 'Request Status',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'noOfCandidates',
    headerName: 'Profiles Received',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'jobDescriptionPath',
    headerName: 'Job Description',
    filterParams: { hideMenu: true },
  },
];
